<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制状态" :value="0"></el-option>
                        <el-option label="仅看未开始的" :value="1"></el-option>
                        <el-option label="仅看进行中的" :value="2"></el-option>
                        <el-option label="仅看已结束的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input
                        placeholder="请输入活动名称"
                        v-model="params.name"
                        size="small"
                    ></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/lottery/activity/edit')" type="primary" icon="el-icon-plus" size="small" @click="add">创建活动</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="ID" min-width="300" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="title" label="活动名称" min-width="200" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="活动时间" min-width="180">
                    <template slot-scope="scope">
                        <p>起：{{scope.row.startTime}}</p>
                        <p>止：{{scope.row.endTime}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="initNum" label="初始每人可抽次数" min-width="120">
                </el-table-column>
                <el-table-column prop="winNum" label="每人最多可中次数" min-width="120">
                </el-table-column>
                <el-table-column label="活动状态">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status == 1">未开始</p>
                        <p v-else-if="scope.row.status == 2" class="color-success">进行中</p>
                        <p v-else-if="scope.row.status == 3" class="color-info">已结束</p>
                    </template>
                </el-table-column>
                <el-table-column prop="lotteryNum" label="抽奖次数">
                </el-table-column>
                <el-table-column prop="winnerNum" label="中奖次数">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="280">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/lottery/activity/edit')"
                            type="text"
                            size="small"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="$utils.have('/lottery/prize/lotteryPrizeList')"
                            type="text"
                            size="small"
                            @click="prizeList(scope.row.id)"
                            >奖品信息</el-button
                        >
                        <el-button
                            v-if="$utils.have('/lottery/activity/statistics') || $utils.have('/lottery/activity/statistics/detail')"
                            type="text"
                            size="small"
                            @click="statistics(scope.row.id)"
                            >活动数据</el-button
                        >
                        <el-button
                            v-if="$utils.have('/lottery/activity/white/list') && scope.row.joinLimit == 2"
                            type="text"
                            size="small"
                            @click="whiteList(scope.row.id)"
                            >白名单</el-button
                        >
						<el-button
						    type="text"
						    size="small"
						    @click="view(scope.row)"
						    >二维码</el-button
						>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
		<CodeView ref="codeView"></CodeView>
    </div>
</template>
<script>
import CodeView from '@/components/CodeView';
const defaultParams = {
    pageNo: 1,
    name: "",
    status: 0,
};
export default {
	components: { CodeView },
    data(){
        return{
            data: null,
            dataList: [],
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                name: this.$route.query.name || '',
                status: parseInt(this.$route.query.status || 0),
            },
            listLoading: true,
			link:''
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/lottery/activity/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
		
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
		//预览
		view(item){
			this.$refs.codeView.show({
                ...item,
                name: item.title,
                qrCodeUrl: item.activityHref,
                redBookUrl: item.redBookUrl,
				showWechart:0,
            })
		},
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        add(){
            this.$router.push({
                path:`/promotion/lottery/add/step1`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        edit(id){
            this.$router.push({
                path:`/promotion/lottery/edit/${id}/step1`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        statistics(id){
            this.$router.push({
                path:`/promotion/lottery/statistics`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                    id: id
                },
            });
        },
        prizeList(id){
            this.$router.push({
                path:`/promotion/lottery/prizeList/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    )
                },
            });
        },
        whiteList(id){
            this.$router.push({
                path:`/promotion/lottery/whiteList/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    )
                },
            });
        }
    }
}
</script>
<style lang="scss" scoped>

</style>